import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'ipm-license-wav-sound',
  templateUrl: './license-wav-sound.component.html',
  styleUrls: ['./license-wav-sound.component.scss']
})
export class LicenseWavSoundComponent implements OnInit, OnChanges {
  @Input() CurrentLicenseData: any;
  currentLicense: any = '';
  currentData: any = '';
  currentDate: any = new Date();
  
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['CurrentLicenseData']) {
      this.currentData = this.CurrentLicenseData;
      
      // For sounds, the license data structure is different
      if (this.currentData?.cartData?.sound_price) {
        this.currentLicense = this.currentData.cartData.sound_price.licence;
      } else if (this.currentData?.currentBeatData?.price) {
        // Sound kit has a single price object, not an array
        this.currentLicense = this.currentData.currentBeatData.price;
      }
    }
  }
}
